module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeSlider"
    }
  }, [_c('div', {
    staticClass: "slider-wrapper",
    style: (("background-image: url(" + _vm.image + ");"))
  }, _vm._l((_vm.slides), function(slide, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.index === i),
        expression: "index === i"
      }],
      key: i,
      staticClass: "slider-content"
    }, [(slide.text) ? _c('Heading', {
      attrs: {
        "type": "h2",
        "size": "m"
      }
    }, [_vm._v(_vm._s(slide.text))]) : _vm._e(), _vm._v(" "), (slide.liItems) ? _c('ul', _vm._l((slide.liItems), function(item) {
      return _c('li', {
        key: item,
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })
    })) : _vm._e(), _vm._v(" "), (slide.logos) ? _c('div', {
      staticClass: "slider-logos"
    }, _vm._l((slide.logos), function(logo, logoInd) {
      return _c('div', {
        key: ("logo_" + logoInd)
      }, [_c('img', {
        attrs: {
          "src": logo
        }
      })])
    })) : _vm._e(), _vm._v(" "), (slide.map) ? _c('div', {
      staticClass: "slider-map"
    }, [_c('img', {
      attrs: {
        "src": slide.map
      }
    })]) : _vm._e(), _vm._v(" "), (slide.news) ? _c('ul', {
      staticClass: "news-item"
    }, _vm._l((slide.news), function(news, ind) {
      return _c('li', {
        key: ind
      }, [_c('a', {
        attrs: {
          "href": news.url
        }
      }, [_c('Heading', {
        attrs: {
          "type": "h5",
          "size": "s"
        }
      }, [_vm._v(_vm._s(news.title))])], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(news.description))])])
    })) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64825610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Slider.vue
// module id = 132
// module chunks = 0